module.exports = __webpack_public_path__ + "img/skyworx-2.1572e542.svg";